"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventResult = exports.EventIntervalResult = exports.EventInterval = void 0;
var get_or_1 = require("@athlinks/get-or");
var time_1 = require("../common/time");
var pace_1 = require("../common/pace");
var distance_1 = require("../common/distance");
var raceType_1 = require("../common/raceType");
var EventInterval = /** @class */ (function (_super) {
    __extends(EventInterval, _super);
    function EventInterval() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.distance = new distance_1.Distance();
        _this.intervalType = '';
        _this.intervalRaceType = raceType_1.IntervalRaceType.UNDEFINED;
        _this.intervalResults = [];
        _this.isLeg = false;
        _this.intervalFull = false;
        _this.intervalId = 0;
        _this.intervalName = '';
        _this.intervalOrder = 0;
        return _this;
    }
    return EventInterval;
}(get_or_1.Transerializable));
exports.EventInterval = EventInterval;
var EventIntervalResult = /** @class */ (function (_super) {
    __extends(EventIntervalResult, _super);
    function EventIntervalResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.age = 0;
        _this.entryId = 0;
        _this.bib = '';
        _this.country = '';
        _this.thirdPartyEntryId = 0;
        _this.displayName = '';
        _this.entryStatus = '';
        _this.entryType = '';
        _this.firstName = '';
        _this.gender = '';
        _this.genderRank = 0;
        _this.intervalName = '';
        _this.intervalOrder = 0;
        _this.lastName = '';
        _this.locality = '';
        _this.overallRank = 0;
        _this.pace = new pace_1.Pace();
        _this.postalCode = '';
        _this.primaryBracketRank = 0;
        _this.racerId = 0;
        _this.region = '';
        _this.regionId = '';
        _this.time = new time_1.Time();
        _this.config = {
            optionalPartialConfig: {
                timeInMilliseconds: {
                    dotPaths: 'ticks',
                    getter: get_or_1.numberOr
                }
            }
        };
        return _this;
    }
    return EventIntervalResult;
}(get_or_1.Transerializable));
exports.EventIntervalResult = EventIntervalResult;
var EventResult = /** @class */ (function (_super) {
    __extends(EventResult, _super);
    function EventResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.courseId = 0;
        _this.eventCourseId = 0;
        _this.eventCourseName = '';
        _this.eventId = 0;
        _this.bracketId = 0;
        _this.bracketName = '';
        _this.bracketRankType = '';
        _this.bracketTag = '';
        _this.bracketType = '';
        _this.interval = new EventInterval();
        _this.thirdParySystemRaceId = 0;
        _this.raceType = raceType_1.RaceType.UNDEFINED;
        _this.totalAthletes = 0;
        _this.totalInBracket = 0;
        _this.hasPace = false;
        return _this;
    }
    return EventResult;
}(get_or_1.Transerializable));
exports.EventResult = EventResult;
//# sourceMappingURL=erpResultResponse.js.map